import SeekAd from './SeekAd';
export default SeekAd;
